import Model from 'flarum/common/Model';

export default class CaseMentorReview extends Model {}

Object.assign(CaseMentorReview.prototype, {
  caseId: Model.attribute('case_id'),
  mentorId: Model.attribute('mentor_id'),
  isPublic: Model.attribute('is_public'),
  isLocked: Model.attribute('is_locked'),
  lockedAt: Model.attribute('locked_at', Model.transformDate),
  content: Model.attribute('content'),
  createdAt: Model.attribute('created_at', Model.transformDate),
  updatedAt: Model.attribute('updated_at', Model.transformDate),

  case: Model.hasOne('case'),
  mentor: Model.hasOne('mentor'),
});
